/**
 File to declare constants related to Optimizely experiments
 */

const PROJECT_ID = '11355970984' // production
const TEST_PROJECT_ID = '17294405044' // stage

/**
 * We have set up proxying for optimizely through our CDN
 * @readonly
 */
const OPTIMIZELY_URL = 'https://optimizely-cdn.ethoslife.com/js'

export const OPTIMIZELY_SCRIPT_SRC = `${OPTIMIZELY_URL}/${PROJECT_ID}.js`
export const OPTIMIZELY_SCRIPT_SRC_DEV = `${OPTIMIZELY_URL}/${TEST_PROJECT_ID}.js`

// Used to trigger Daily Premium pricing on BoF Package Select
// Also used to trigger Quick Scan treatment on PreInterview /q/recommendation
export const DAILY_DOLLARS_COOKIE = {
  NAME: 'ETHOS_DAILY_DOLLARS_TOF',
  EW_VALUE: 'DAILY_EW',
}

/**
 * Experiment to simulate a landing page that looks like the start of the main app
 */

export const ASTA = {
  VARIATIONS: {
    TREATMENT: 'TREATMENT',
  },
  COOKIE_NAME: 'asta', // same as experiment key but want to be explicit
}

// https://app.optimizely.com/v2/projects/15340850549/flags/manage/wills_v3_3_gc-5243/rules/development/edit/wills_v3_3_gc-5243
export const WILLS_V3_4 = {
  EXPERIMENT_KEY: 'wills_v3_4_gc-5331',
  VARIATIONS: {
    CONTROL: 'control',
    TREATMENT_1: 'treatment_1',
    TREATMENT_2: 'treatment_2',
    TREATMENT_3: 'treatment_3',
    TREATMENT_4: 'treatment_4',
  },
}

// https://app.optimizely.com/v2/projects/15340850549/flags/manage/wills_new_meta_lp-gc-5369/rules/development/edit/wills_new_meta_lp-gc-5369
export const WILLS_META_AFFILIATE_LP = {
  EXPERIMENT_KEY: 'wills_v3_4_gc-5481',
  VARIATIONS: {
    CONTROL: 'control',
    TREATMENT_1: 'treatment_1',
    TREATMENT_2: 'treatment_2',
    TREATMENT_3: 'treatment_3',
    TREATMENT_4: 'treatment_4',
  },
}

export const HOMEPAGE_BRAND_REFRESH = {
  EXPERIMENT_KEY: 'homepage-brand-refresh-ceq-940',
  VARIATIONS: {
    CONTROL: 'off',
    TREATMENT_1: 'treatment_1',
    TREATMENT_2: 'treatment_2',
  },
}

export const WILLS_NEW_HERO_SECTION = {
  EXPERIMENT_KEY: 'gc-5806-wills-new-hero-section',
  VARIATIONS: {
    CONTROL: 'off',
    TREATMENT_1: 'treatment_1',
    TREATMENT_2: 'treatment_2',
  },
}

export const WREATHS_FOOTER_UPDATE = {
  EXPERIMENT_KEY: 'wreathsv2_footer_update-gc-6721',
  VARIATIONS: {
    CONTROL: 'off',
    TREATMENT_1: 'variant_1',
  },
}

export const HEADLINE_TEST_TREATMENT_CEQ380 = {
  EXPERIMENT_KEY: 'headline-treatement-ceq380',
  VARIATIONS: {
    CONTROL: 'off',
    TREATMENT_1: 'treatment_1',
    TREATMENT_2: 'treatment_2',
    TREATMENT_3: 'treatment_3',
  },
}

export const CTA_TREATMENT = {
  EXPERIMENT_KEY: 'cta_treatment_ceq2-377',
  VARIATIONS: {
    CONTROL: 'off',
    TREATMENT_1: 'treatment_1',
  },
}

export const TRUSTAGE_LANDING_PAGE = {
  EXPERIMENT_KEY: 'trustage_landing_page-gc-5024',
  VARIATIONS: {
    CONTROL: 'off',
    TREATMENT: 'treatment',
  },
  MODULE_EXP_KEY: 'trustageLandingPage-off',
}

// https://app.optimizely.com/v2/projects/15340850549/flags/manage/wills_v3_5_gc-5528/rules/development/edit/wills_v3_5_gc-5528
export const WILLS_V3_5 = {
  EXPERIMENT_KEY: 'wills_v3_5_gc-5528',
  VARIATIONS: {
    CONTROL_5: 'control_5',
    TREATMENT_1: 'treatment_1',
    TREATMENT_2: 'treatment_2',
  },
}

export const LOGIN_CTA_EXPERIMENT = {
  EXPERIMENT_KEY: 'add_login_to_top_nav_cdt_547',
  VARIATIONS: {
    CONTROL: 'cdt_547_control',
    TREATMENT_1: 'cdt_547_treatment_1',
  },
}

export const DUAL_CTA_HOMEPAGE = {
  EXPERIMENT_KEY: 'dual_cta_v3_ceq2-1056',
  VARIATIONS: {
    CONTROL: 'off',
    TREATMENT: 'on',
  },
}

// https://app.optimizely.com/v2/projects/15340850549/flags/manage/wills_v3_6_gc-6321/rules/test/edit/wills_v3_6_gc-6321
export const WILLS_V3_6 = {
  EXPERIMENT_KEY: 'wills_v3_6_gc-6321',
  VARIATIONS: {
    CONTROL: 'control',
    TREATMENT_1: 'treatment_1',
    TREATMENT_2: 'treatment_2',
    TREATMENT_3: 'treatment_3',
  },
}

export const WILLS_V3_7 = {
  EXPERIMENT_KEY: 'wills_v3_7_ceq2-443',
  VARIATIONS: {
    CONTROL: 'control',
    TREATMENT_1: 'treatment_1',
    TREATMENT_5: 'treatment_5',
  },
}

export const WILLS_V3_8 = {
  EXPERIMENT_KEY: 'wills_v3_8_ceq2-774',
  VARIATIONS: {
    CONTROL: 'control',
    TREATMENT_1: 'treatment_1',
    TREATMENT_2: 'treatment_2',
    TREATMENT_3: 'treatment_3',
  },
}

export const DIRECT_TO_APP = {
  EXPERIMENT_KEY: 'direct_to_app_ceq2-533',
  VARIATIONS: {
    OFF: 'off',
    VARIANT_1: 'variant_1',
    VARIANT_2: 'variant_2',
    VARIANT_3_5: 'variant_3_5',
  },
}

// https://app.optimizely.com/v2/projects/15340850549/flags/manage/w_t_v3_9/rules/development/edit/w_t_v3_9
export const WILLS_V3_9 = {
  EXPERIMENT_KEY: 'w_t_v3_9',
}

// https://app.optimizely.com/v2/projects/15340850549/flags/manage/wills-v3-10-ceq2-1290/rules/development/edit/wills-v3-10-ceq2-1290
export const WILLS_V3_10 = {
  EXPERIMENT_KEY: 'wills-v3-10-ceq2-1290',
  VARIATIONS: {
    CONTROL: 'control',
    TREATMENT_1: 'treatment_1',
    WILLS_V3_9: 'wills_v3_9',
  },
}
// https://app.optimizely.com/v2/projects/15340850549/flags/manage/wills_v3_12_attorney_review_ceq3-113/rules/development/edit/wills_v3_12_attorney_review_ceq3-113
export const WILLS_V3_12 = {
  EXPERIMENT_KEY: 'wills_v3_12_attorney_review_ceq3-113',
  VARIATIONS: {
    CONTROL: 'control',
    TREATMENT_1: 'treatment_1',
    TREATMENT_2: 'treatment_2',
  },
}

// https://app.optimizely.com/v2/projects/15340850549/flags/manage/wills_v3_11_for_meta_ceq3-32/rules/development
export const WILLS_V3_11 = {
  EXPERIMENT_KEY: 'wills_v3_11_for_meta_ceq3-32',
  VARIATIONS: {
    CONTROL: 'control',
    TREATMENT_1: 'treatment_1',
  },
}

// https://app.optimizely.com/v2/projects/15340850549/flags/manage/dual_ads_landing_ceq2-1050/rules/development/edit/dual_ads_landing_ceq2-1050
export const DUAL_ADS_LANDING = {
  EXPERIMENT_KEY: 'dual_ads_landing_ceq2-1050',
  VARIATIONS: {
    OFF: 'off',
    ON: 'on',
  },
}

// https://app.optimizely.com/v2/projects/15340850549/flags/manage/brand_colors_refresh_ceq2-1332
export const BRAND_COLORS_REFRESH = {
  EXPERIMENT_KEY: 'brand_colors_refresh_ceq2-1332',
  VARIATIONS: {
    CONTROL: 'off',
    TREATMENT_1: 'treatment_1',
  },
}

export const REBRANDING_REFRESH = {
  EXPERIMENT_KEY: 'brand_fonts_refresh_ceq2-1605',
  VARIATIONS: {
    CONTROL: 'off',
    TREATMENT: 'on',
  },
}
